import { setup, Vue } from "vue-class-component";
import { Options, Prop, Emit } from "vue-property-decorator";
import { useI18n } from "@/shared/composables/use-i18n";

@Options({})
export class AppModal extends Vue {
    @Prop({ required: true, default: false })
    visible: boolean = false;
    @Prop() maxWidth: string = "440px";
    @Prop({ required: true, default: "common.ok" })
    submitButtonText: string = "";
    @Prop({
        required: true,
        default: "dashboard.myAccountComponent.companyInfoTab.teamMembers.form.cancel",
    })
    cancelButtonText: string = "";
    @Prop({ required: false, default: true })
    visibleCancelBtn: boolean = true;

    @Prop({ required: false, default: true })
    visibleFooter: boolean = true;
    @Prop({ required: false, default: false })
    submitButtonIsRed: boolean = false;

    i18n = setup(useI18n);

    submit() {
        this.$emit("submit");
    }

    @Emit("closeModal")
    cancel() {
        return false;
    }

    closeModal(e: any) {
        e.preventDefault();

        this.cancel();
    }
}
